export const CHALLENGE_EAST = 'east'; // V3
export const CHALLENGE_WEST = 'west'; // V2

export const CH_AVAILABILITY_BOOKING = 'permitAvailabilityGridBooking';
export const CH_PERMIT_VENUE_BOOKING = 'permitVenueBooking';
export const CH_COMMERCIAL_ALLOCATION_BOOKING = 'permitCommercialAllocationBooking';